export const BASE_PAGE_PRICE = 19.99;
export const INCLUDED_PHOTOS = 3;
export const EXTRA_PHOTO_PRICE = 1;

export function getExtraPhotoCount(imageCount: number): number {
	return Math.max(0, imageCount - INCLUDED_PHOTOS);
}

export function getPageTotalPrice(imageCount: number): number {
	return BASE_PAGE_PRICE + getExtraPhotoCount(imageCount) * EXTRA_PHOTO_PRICE;
}

export function formatPriceBRL(value: number): string {
	return value.toFixed(2).replace(".", ",");
}
